import { TKeys } from 'utils/enums';
import { getMessageText } from 'utils/helpers';
import { ALPHA_NUMBER_REGEX } from 'utils/regex';
import * as yup from 'yup';

export const resetPasswordSchema = (t: (key: string) => string) =>
    yup.object().shape({
        password: yup
            .string()
            .required(getMessageText(t(TKeys.MSE00001), t(TKeys.LBL010014)))
            .matches(ALPHA_NUMBER_REGEX, getMessageText(t(TKeys.MSE00034), t(TKeys.LBL010014)))
            .min(8, getMessageText(t(TKeys.MSE00027), t(TKeys.LBL010014), 8))
            .max(40, getMessageText(t(TKeys.MSE00004), t(TKeys.LBL010014), 40)),

        confirmPassword: yup
            .string()
            .oneOf([yup.ref('password')], t(TKeys.MSE00011))
            .required(getMessageText(t(TKeys.LBL010017))),
    });
